<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-xbox-controller-menu</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="usermenus"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="[v => !!v || 'Item is required']"
                        label="User ID"
                        required
                        :disabled="true"
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiMenu_id"
                        :items="menus"
                        :rules="[v => !!v || 'Item is required']"
                        label="Menu ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenuOrder_id" 
                        label="Menu Order"  :type="'text'"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO MENU - USUARIO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="[v => !!v || 'Item is required']"
                        label="User ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiMenu_id"
                        :items="menus"
                        :rules="[v => !!v || 'Item is required']"
                        label="Menu ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field v-model="editedItem.ApiMenuOrder_id" 
                        label="Menu Order"  :type="text"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'User ID', value: 'ApiUser_id' },
      { text: 'Menu ID', value: 'ApiMenu_id' },
      { text: 'Menu Order', value: 'ApiMenuOrder_id' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    usermenus: [],
    menus: [],
    users: [],
    editedIndex: -1,
    editedItem: {
      ApiUser_id: '',
      ApiMenu_id: '',
      ApiMenuOrder_id: ''
    },
    defaultItem: {
      ApiUser_id: '',
      ApiMenu_id: '',
      ApiMenuOrder_id: ''
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
    ],
    descRules: [
      v => !!v || 'Rol Descripcion es requerido',
      v => (v && v.length <= 61) || 'Role Descripcion debe tener menos de 30 caracteres',
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Menu' : 'Editar Menu'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_usermenu', {}, this.config)
      .then(response => {
        this.usermenus = response.data.ResultRows
      })
      .catch(error => {
        this.usermenus = []
        alert(error.response.data.message)
      })

      axios.post(this.api_tool_url + '/get_menu', {}, this.config)
      .then(response => {
        response.data.ResultRows.forEach(data => {
            this.menus.push(data.ApiMenu_id)
          })
      })
      .catch(error => {
        this.menus = []
        alert(error.response.data.message)
      })

      axios.post(this.api_tool_url + '/get_users', {}, this.config)
      .then(response => {
        response.data.ResultRows.forEach(data => {
            this.users.push(data.ApiUser_id)
          })
      })
      .catch(error => {
        this.users = []
        alert(error.response.data.message)
      })
      
    },

    newtItem (item) {
      this.editedIndex = this.usermenus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.usermenus.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.usermenus.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteUserMenu(index)
    },

    deleteUserMenu(index) {
      let usermenus_tmp = this.usermenus[index]
      delete usermenus_tmp.ApiMenuOrder_id
      axios.post(this.api_tool_url + '/del_usermenu', usermenus_tmp, this.config)
        .then(response => {
          this.usermenus.splice(index, 1)
          this.close()
          })
        .catch(error => {
          this.usermenus = []
          alert(error.response.data.message)
          })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_usermenu', this.editedItem, this.config)
        .then(response => {
          Object.assign(this.usermenus[this.editedIndex], response.data.ResultRows[0])
          this.close()
          })
        .catch(error => {
          this.usermenus = []
          alert(error.response.data.message)
          })
        //Object.assign(this.users[this.editedIndex], this.editedItem)
      } else {
        axios.post(this.api_tool_url + '/ins_usermenu', this.editedItem, this.config)
        .then(response => {
          //console.log(response)
          this.usermenus.push(response.data.ResultRows[0])
          this.close()
        })
        .catch(error => {
          this.usermenus = []
          alert(error.response.data.message)
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/UserMenuGrid.vue